export const environment = {
    "aws": {
        "Auth": {
            "authenticationFlowType": "USER_PASSWORD_AUTH",
            "cookieStorage": {
                "domain": ".examsoft.com",
                "expires": 365,
                "path": "/",
                "secure": true
            },
            "identityPoolId": "eu-west-1:48f9ffa1-ed76-4665-b054-70dcc3114bff",
            "identityPoolRegion": "eu-west-1",
            "region": "eu-west-1",
            "userPoolId": "eu-west-1_9X6ST8sW0",
            "userPoolWebClientId": "4cqrnvid6sl8b77jrd1h7hgbur"
        },
        "oauth": {
            "domain": "cog010euirprod.auth.eu-west-1.amazoncognito.com",
            "options": {
                "AdvancedSecurityDataCollectionFlag": true
            },
            "redirectSignIn": "window.location.origin",
            "redirectSignOut": "window.location.origin",
            "responseType": "code",
            "scope": [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin"
            ]
        }
    },
    "esLogin": "https://login-ir.examsoft.com/",
    "production": true,
    "urls": {
        "institutionApiUrl": "https://cog010-api-prod.examsoft.com/institutions",
        "usage": "https://plt010-api-prod.examsoft.com/usage"
    }
};